import React, { memo } from 'react'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

import styles from './ProcessForwardingCard.module.sass'

const ProcessForwardingCard = memo(
	(props) => {
		const { className, data, ...attributes } = props
		const labels = data.$cardLabels || {}

		const hasDataValidationInfo = Object.values(
			data.dataValidation || {}
		).find(({ value }) => value)

		return (
			<div
				{...attributes}
				className={`card ${styles['root'] || ''} ${className || ''}`}
				onClick={() => {
					data.$action && data.$action()
				}}
			>
				<span className={styles['status-circle']} />
				<span className={styles['info-container']}>
					<h5>{labels.forwarding}</h5>
					<small>
						{data.completionDate?.shortDateFormat} •{' '}
						{data.completionUser?.name}
					</small>
				</span>
				{hasDataValidationInfo && data.disparity.hasDisparity && (
					<Icon name='warning' width='22px' height='22px' />
				)}
			</div>
		)
	},
	(prevProps, nextProps) =>
		prevProps.data.id === nextProps.data.id &&
		prevProps.data.textHeight === nextProps.data.textHeight &&
		prevProps.data.$layout === nextProps.data.$layout &&
		prevProps.data.$detailLevel === nextProps.data.$detailLevel &&
		prevProps.style.top === nextProps.style.top &&
		prevProps.data.$highlight === nextProps.data.$highlight
)
ProcessForwardingCard.displayName = 'ProcessForwardingCard'
ProcessForwardingCard.defaultHeight = 56

export default ProcessForwardingCard
